import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  viewboxWidth: 16,
  viewboxHeight: 16,
};

const BuildingIcon = ({
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      viewboxHeight={viewboxHeight}
      viewboxWidth={viewboxWidth}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.027 2.93c.005.035.01.053.01.072 0 .623-.001 1.246.002 1.87 0 .088-.042.094-.11.094-.602-.001-1.205-.003-1.807.001-.097.001-.118-.035-.117-.124.003-.598.004-1.195-.001-1.792 0-.105.037-.123.13-.122.576.004 1.152.002 1.729.002h.164Zm0 6.075H9.015v-2.01h2.012v2.01Zm-4.045-4.05c-.028.005-.046.01-.065.01-.62 0-1.242-.001-1.863.002-.097 0-.097-.051-.096-.121 0-.598.003-1.195-.002-1.792 0-.101.03-.126.126-.125.595.004 1.19.002 1.786.002.036 0 .072.004.114.006v2.018Zm-.002 4.05H4.966V6.995H6.98v2.012ZM0 0v2.015h.999v13.983h5.474v-4.03h3.054V16h5.466V2.191c0-.194-.013-.17.166-.171h.715c.04 0 .08-.004.126-.006V0H0Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default BuildingIcon;
